export default {
  title: "Confirming your e-mail...",
  successMessage: "Your e-mail has been successfully confirmed.",
  userNotFound: "User with such e-mail wasn't found.",
  incorrentCode: "Wrong confirmation code.",
  serverError: "Server error."
};
